module.exports = __webpack_public_path__ + "assets1783936157458/img/tag-new.f3d18b93.svg";